var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"form",attrs:{"methods":_vm.methods,"form":_vm.form,"config":_vm.config}})}
var staticRenderFns = []

export { render, staticRenderFns }